
const mixin = {
  data() {
    return {
      Model: {
        orgName: null,
        orgType: null,
        orgDocumentsType: null,
        orgDocumentsNo: null,
        orgDocumentsValidity: null,
        orgQualificationProve: null,
        orgQualificationNo: null,
        orgBusinessScope: null,
        orgRegisterAddress: '',
        orgAddress: '',
        orgRegisteredCapital: null,
        orgController: '',
        isOrgValidateForever: false,
      },
      options: {
        scrollToInvalidField: false,
      },
      Fields: [
        {
          type: 'input',
          modelKey: 'orgName',
          label: '机构名称',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgType',
          label: '机构类型',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgDocumentsType',
          label: '证件类型',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgDocumentsNo',
          label: '证件编号',
          props: {
            type: 'tel',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgDocumentsValidity',
          label: '证件有效期',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgQualificationProve',
          label: '资质证书',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgQualificationNo',
          label: '证书编号',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgRegisteredCapital',
          label: '注册资本(万元)',
          props: {
            type: 'number',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgBusinessScope',
          label: '经营范围',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'input',
          modelKey: 'orgController',
          label: '股东或控股人',
          props: {
            type: 'text',
            disabled: true,
          },
        },
        {
          type: 'textarea',
          modelKey: 'orgRegisterAddress',
          label: '注册地址',
          props: {
            disabled: true,
            placeholder: '',
          },
        },
        {
          type: 'textarea',
          modelKey: 'orgAddress',
          label: '办公地址',
          props: {
            disabled: true,
            placeholder: '',
          },
        },
      ],
    };
  },
};
export default mixin;
